import { type InjectionKey, provide, type Ref, ref } from 'vue'

import type { ReturnAdPreviewType } from '@/lib/types/return-ad.types'

type PreviewDataFlagType = {
  valueRef: Ref<ReturnAdPreviewType | undefined>
  update: (data: ReturnAdPreviewType) => void
}
export const previewDataProvideFlag = Symbol() as InjectionKey<PreviewDataFlagType>

export const usePreviewData = () => {
  const previewData = ref<ReturnAdPreviewType>()

  const updatePreviewData = (data: ReturnAdPreviewType) => {
    previewData.value = data
  }

  provide(previewDataProvideFlag, {
    valueRef: previewData,
    update: updatePreviewData,
  })
}
